import type { FaireProductEntity } from "../../entity_types/product";

export const p_e9ecrg7vcw: FaireProductEntity = {
  token: "p_e9ecrg7vcw",
  type: "product",
  name: "Gone Green Sencha",
  brandToken: "b_6su5v1sirt",
  brandName: "Highwire Coffee Roasters",
  imageUrl: "https://cdn.faire.com/fastly/612766bd767330f84fcf08eac0dfdb1d4f814090049341754252cba44e955c0d.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e7d0ba80ba9d1f8bb9a9ce4049602d9391f879a469279c4b4e09ed62a65414d2.jpeg",
    "https://cdn.faire.com/fastly/1a74150b6c8215f4f4271b39fe77a5e9440f8ed0a0518ca4f0314ade7525f7b8.png"
  ],
  priceDollars: 16.8,
  description: "Profile: Comforting, fresh greens, soft.\n\nGone Green has always been a spring-grown Sencha from Japan, and in 2018 we were excited to find a certified organic example that measured up to our high flavor bar. We named it for the saturated green color and flavor of this lovely tea, with a nod to a favorite New Order song. This is a comforting, approachable green tea that’s easy to love.\n\nWe recommend brewing 1g of tea for 2oz of water at 165° for 1.5 minutes.",
  tags: [],
  msrpDollars: 24,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-08T20:57:55.781Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
